import React from "react";
import { cva } from "class-variance-authority";

import { cn } from "utils/cn";

const inputVariants = cva(
  "block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6",
  {
    variants: {
      size: {
        sm: "p-1.5",
        md: "text-md p-3",
        lg: "p-4 text-lg",
      },
      disabled: {
        true: "",
        false: "",
      },
    },
    compoundVariants: [
      {
        disabled: true,
        class: "pointer-events-none",
      },
    ],
    defaultVariants: {
      size: "sm",
    },
  },
);

const Input = React.forwardRef(({ label, size, disabled, className, ...props }, ref) => {
  return (
    <div className="min-w-52 flex-1 flex-col">
      {!!label && (
        <label htmlFor={props.name} className="mb-2 mt-3 block text-sm font-medium leading-6 text-gray-900">
          {label}
        </label>
      )}

      <input className={cn(inputVariants({ disabled, size }), className)} disabled={disabled} ref={ref} {...props} />
    </div>
  );
});

Input.displayName = "Input";

export { Input };
